import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from "../../../components/common/CustomModal";
import CreateBooking from "../CreateForm/CreateBooking";
import { useShipmentDetails } from './useShipmentDetails';
import { DELETE_IMPORT_SHIPPING_BOOKING, LIST_IMPORT_SHIPPING_BOOKINGS, LIST_PROFORMA_INVOICES } from '../../../services/apiRoutes';
import { genericPost } from '../../../services/authServices';
import UpdateBooking from '../UpdateForm/UpdateBooking';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { getCIFFOBList, getCurrencyList, getCustomClearingAgencyData, getDirectListData, getFCLData, getFreightForwardAgencyData, getShippingLines, getCommanImportShipmentId, getPortMasters } from '../../../services/CommonServices';
import ShippingBookingView from '../ViewDetails/ShippingBookingView';
import { Box } from '@mui/material';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import BookOnlineOutlinedIcon from '@mui/icons-material/BookOnlineOutlined';
import CustomStatus from '../../common/CustomStatus';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";


export default function Booking({ fetchButtonList }) {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();
    const { importShipmentId } = useParams();
    const [open, setOpen] = useState(true);
    const [leadModal, setLeadModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });
    const [shippingBookingId, setShippingBookingId] = useState('');
    const [viewModal, setViewModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('Booking');
    const [shippingLines, setShippingLines] = useState([]);
    const [portMasters, setPortMasters] = useState([]);
    const [fclData, setFCLData] = useState([]);
    const [directListData, setDirectListData] = useState([]);
    const [freightForwardAgencyData, setFreightForwardAgencyData] = useState([]);
    const [customClearingAgencyData, setCustomClearingAgencyData] = useState([]);
    const [cifFobList, setCIFFOBList] = useState([]);
    const [currencyList, setCurrencyList] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')
    const [proformaInvoiceList, setProformaInvoiceList] = useState([]);
    const [bookingNumber, setBookingNumber] = useState("");

    const { shipmentDetails, loading: shipmentLoading } = useShipmentDetails(importShipmentId);
    let supplierId, cifFob;

    const hasFetched = useRef(false);

    useEffect(() => {
        if (shipmentDetails) {
            supplierId = shipmentDetails.supplierId;
            cifFob = shipmentDetails.cifFob.cifFobName;
            fetchData();
            getCommonData();
            getProformaInvoice();
            hasFetched.current = true;
        }
    }, [shipmentDetails, updateModal, shippingBookingId, leadModal, deleteAlert, token]);


    // const getProformaInvoice = async () => {
    //     try {
    //         const payload = {
    //             supplierNamesId: supplierId,
    //             shipmentId: shipmentId
    //         };
    //         const response = await genericPost(LIST_PROFORMA_INVOICES, payload, {
    //         });
    //         if (response.data && response.data.success && response.data.proformaInvoice) {
    //             const proform = response.data.proformaInvoice.map((invoice) => ({
    //                 id: invoice.proformaInvoiceId || '',
    //                 title: invoice.proformaInvoiceNo || '',
    //                 qty: invoice.particulars.qty || '',
    //             }));
    //             setProformaInvoiceList(proform);
    //         } else {
    //             return [];
    //         }
    //     } catch (error) {
    //         console.error('Error fetching suppliers list:', error);
    //         return [];
    //     }
    // };

    const getProformaInvoice = async () => {
        try {
            const payload = {
                supplierNamesId: supplierId,
                shipmentId: shipmentId,
            };

            const response = await genericPost(LIST_PROFORMA_INVOICES, payload);

            if (response.data && response.data.success && response.data.proformaInvoice) {
                const proform = response.data.proformaInvoice.map((invoice) => {
                    // ✅ Calculate total qty from all particulars
                    const totalQty = invoice.particulars?.reduce((sum, item) => {
                        return sum + Number(item.qty || 0);
                    }, 0);

                    return {
                        id: invoice.proformaInvoiceId || '',
                        title: invoice.proformaInvoiceNo || '',
                        totalQty: totalQty,
                    };
                });

                setProformaInvoiceList(proform);
            } else {
                setProformaInvoiceList([]);
            }
        } catch (error) {
            console.error('Error fetching proforma invoices:', error);
            setProformaInvoiceList([]);
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: supplierId,
                commanShipmentId: getCommanImportShipmentId,
                shipmentId: shipmentId,

            };
            const response = await genericPost(LIST_IMPORT_SHIPPING_BOOKINGS, payload, {
            });

            if (response.data.success && response.data.shippingBooking) {
                const shippingBookingData = response.data.shippingBooking.map((booking, index) => ({
                    index: (index + 1).toString().padStart(2, '0'),
                    shippingBookingId: booking.shippingBookingId || '',
                    blCharges: `${booking?.baseCurrency?.currency_symbol || ''} ${booking.blCharges || ''}`,
                    conversionRate: `${booking?.baseCurrency?.currency_symbol || ''} ${booking.conversionRate || ''}`,
                    destinationCharges: `${booking?.baseCurrency?.currency_symbol || ''} ${booking.destinationCharges || ''}`,
                    shippingLineCharges: `${booking?.baseCurrency?.currency_symbol || ''} ${booking.shippingLineCharges || ''}`,
                    seaFreight: `${booking?.currency?.currency_symbol || ''} ${booking.seaFreight || ''}`,
                    shipmentId: shipmentId || '',
                    bookingNumber: booking.bookingNumber || '',
                    portOfLoading: booking.portOfLoading || '',
                    portOfDestination: booking.portOfDestination || '',
                    proformaInvoiceNo: booking?.ProformaInvoice?.proformaInvoiceNo || '',
                    etaDate: companyDateFormat(booking?.etaDate) || '',
                    etdDate: companyDateFormat(booking?.etdDate) || '',
                    numberOfContainers: booking.numberOfContainers || '',
                    qty: booking.qty || '',
                    perContainer: booking.perContainer || '',
                    cifFobName: booking.cifFob?.cifFobName || '',
                    cifFobId: booking.cifFob?.cifFobId || '',
                    shippingLineName: booking.shippingLines?.shippingLineName || '',
                    agencyName: booking.freightForwardAgency?.agencyName || '',
                    chaName: booking.customClearingAgency?.chaName || '',
                    cifFobNameBg: booking.cifFob?.ColorPlate?.backgroundColor || '',
                    cifFobNameColor: booking.cifFob?.ColorPlate?.color || '',
                    shippingLineColor: booking.shippingLines?.ColorPlate?.color || '',
                    shippingLineBg: booking.shippingLines?.ColorPlate?.backgroundColor || '',
                    agencyColor: booking.freightForwardAgency?.ColorPlate?.color || '',
                    agencyBg: booking.freightForwardAgency?.ColorPlate?.backgroundColor || '',
                    chaColor: booking.customClearingAgency?.ColorPlate?.color || '',
                    chaBg: booking.customClearingAgency?.ColorPlate?.backgroundColor || '',
                    loadingName: `${booking?.loading?.portName || ""}, ${booking?.loading?.country?.name || ""}`.trim(),
                    destinationName: `${booking?.destination?.portName || ""}, ${booking?.destination?.country?.name || ""}`.trim(),

                }));
                setData(shippingBookingData);
                setBookingNumber(response.data.newBookingNumber || "");

            } else {
                setError('No shipping bookings found');
            }
        } catch (error) {
            setError('Error fetching shipping bookings');
            console.error('Error fetching shipping bookings', error);
        } finally {
            setLoading(false);
        }
    };

    if (!shipmentDetails) {
        return (
            <Box>
                <CustomLoader open={shipmentLoading} />
            </Box>
        );
    }
    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }


    const handleDelete = async (shippingBookingId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');
        try {
            const response = await axios.delete(DELETE_IMPORT_SHIPPING_BOOKING(shippingBookingId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            if (response.status === 200) {
                setDeleteAlert(false);
                fetchButtonList();
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };


    const getCommonData = async () => {
        const shippingLines = await getShippingLines();
        setShippingLines(shippingLines);
        const fclData = await getFCLData();
        setFCLData(fclData);
        const directListData = await getDirectListData();
        setDirectListData(directListData);
        const freightForwardAgencyData = await getFreightForwardAgencyData();
        setFreightForwardAgencyData(freightForwardAgencyData);
        const customClearingAgencyData = await getCustomClearingAgencyData();
        setCustomClearingAgencyData(customClearingAgencyData);
        const cifFobListData = await getCIFFOBList();
        setCIFFOBList(cifFobListData);
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
        const getPortMastersData = await getPortMasters()
        setPortMasters(getPortMastersData)
    }

    const handleScrollTo = (menu) => {
        setActiveTab(menu);
    };

    const handleOpen = () => {
        setLeadModal(true);
    };

    const handleClose = () => {
        setLeadModal(false);
    };


    const handleUpdateClick = (id) => {
        setShippingBookingId(id);
        setUpdateModal(true);
    };


    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setShippingBookingId('');
    };

    const handleOpenView = (id) => {
        setShippingBookingId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setShippingBookingId('');
    };


    const handleViewClick = (id) => {
        handleOpenView(id);
    };

    const ShippingBookingCardColumns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            accessor: 'bookingNumber', label: 'Booking Number', id: 'bookingNumber', styleAccessor: {
                textAlign: 'center'
            },
        },
        {
            accessor: 'shipmentId', label: 'Shipment ID', id: 'shipmentId', styleAccessor: {
                textAlign: 'center'
            },
        },
        {
            accessor: 'proformaInvoiceNo', label: 'proforma Invoice', id: 'shipmentId', styleAccessor: {
                textAlign: 'center'
            },
        },
        { accessor: 'loadingName', label: 'Port Of Loading', id: 'lp' },
        { accessor: 'destinationName', label: 'Port Of Destination', id: 'dp' },
        {
            accessor: 'etdDate', label: 'ETD Date', id: 'etdDate', styleAccessor: {
                textAlign: 'center'
            },
        },
        {
            accessor: 'etaDate', label: 'ETA Date', id: 'etaDate', styleAccessor: {
                textAlign: 'center'
            },
        },
        {
            id: 'cifFob',
            label: 'CIF/FOB',
            accessor: 'cifFob',
            styleAccessor: { textAlign: 'center' },
            Cell: ({ row }) => {
                return (
                    <CustomStatus
                        title={row.cifFobName}
                        sx={{
                            backgroundColor: row.cifFobNameBg,
                            color: row.cifFobNameColor,
                            border: `1px solid ${row.cifFobNameColor}`,
                            textAlign: 'center',
                            display: 'inline-block',
                        }}
                    />
                );
            },
        },
        {
            accessor: 'seaFreight', label: 'Sea Freight', id: 'seaFreight', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            accessor: 'destinationCharges', label: 'Others Charges', id: 'destinationCharges', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            accessor: 'shippingLineCharges', label: 'Shipping Line Charges', id: 'shippingLineCharges', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            accessor: 'blCharges', label: 'BL Charges', id: 'blCharges', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            accessor: 'conversionRate', label: 'Conversion Rate', id: 'conversionRate', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            accessor: 'qty', label: 'Quantity', id: 'qty', styleAccessor: {
                textAlign: 'center'
            },
        },
        {
            accessor: 'perContainer', label: 'Per Container', id: 'perContainer', styleAccessor: {
                textAlign: 'center'
            },
        },
        {
            accessor: 'numberOfContainers', label: 'No. of Containers', id: 'numberOfContainers', styleAccessor: {
                textAlign: 'center'
            },
        },
        {
            accessor: 'shippingLineName', label: 'Shipping Line', id: 'shippingLineName',
            styleAccessor: { textAlign: 'center' },
            Cell: ({ row }) => {
                return (
                    <CustomStatus
                        title={row.shippingLineName}
                        sx={{
                            backgroundColor: row.shippingLineBg,
                            color: row.shippingLineColor,
                            border: `1px solid ${row.shippingLineColor}`,
                            textAlign: 'center',
                            display: 'inline-block',
                        }}
                    />
                );
            },
        },
        {
            accessor: 'agencyName', label: 'Freight Forward Agency', id: 'agencyName',
            styleAccessor: { textAlign: 'center' },
            Cell: ({ row }) => {
                return (
                    <CustomStatus
                        title={row.agencyName}
                        sx={{
                            backgroundColor: row.agencyBg,
                            color: row.agencyColor,
                            border: `1px solid ${row.agencyColor}`,
                            textAlign: 'center',
                            display: 'inline-block',
                        }}
                    />
                );
            },
        },
        {
            accessor: 'chaName', label: 'Clearing Agency (CHA)', id: 'chaName',
            styleAccessor: { textAlign: 'center' },
            Cell: ({ row }) => {
                return (
                    <CustomStatus
                        title={row.chaName}
                        sx={{
                            backgroundColor: row.chaBg,
                            color: row.chaColor,
                            border: `1px solid ${row.chaColor}`,
                            textAlign: 'center',
                            display: 'inline-block',
                        }}
                    />
                );
            },
        },

        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.shippingBookingId)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.shippingBookingId)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.shippingBookingId)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];


    const shipmentId = shipmentDetails.shipmentId;
    const companyName = shipmentDetails.supplier.clientCompanyName;
    const phoneNumber = shipmentDetails.supplier.mobile;
    const clientCompanyId = shipmentDetails.supplierId;
    const cifFobId = shipmentDetails.cifFobId;
    const currencySymbol = shipmentDetails?.company?.baseCurrencyData?.currency_symbol ?? '';
    const baseCurrencyId = shipmentDetails?.company?.baseCurrencyData?.id ?? '';
    const currencyId = shipmentDetails.currencyId;
    const currencySym = shipmentDetails?.currency?.currency_symbol ?? '';
    const shipmentOrgId = shipmentDetails.importShipmentId;
    const portOfLoading = shipmentDetails?.portOfLoading ?? '';
    const portOfDestination = shipmentDetails?.portOfDestination ?? '';

    return (
        <div>
            <CustomLoader open={loading} />
            <DetailsPageCard
                Icon={BookOnlineOutlinedIcon}
                columns={ShippingBookingCardColumns}
                title={'Shipping booking'}
                buttonTitle={'Create booking'}
                handleOpen={handleOpen}
                data={data}
                loading={loading}
                error={error}
            />
            <CustomModal open={leadModal}  >
                <CreateBooking
                    fetchData={fetchData}
                    clientCompanyId={clientCompanyId}
                    shippingLines={shippingLines}
                    commanShipmentId={getCommanImportShipmentId}
                    fclData={fclData}
                    directListData={directListData}
                    freightForwardAgencyData={freightForwardAgencyData}
                    customClearingAgencyData={customClearingAgencyData}
                    cifFobList={cifFobList}
                    shipmentId={shipmentId}
                    currencyList={currencyList}
                    cifFobId={cifFobId}
                    currencyId={currencyId}
                    currencySymbol={currencySymbol}
                    baseCurrencyId={baseCurrencyId}
                    currencySym={currencySym}
                    setMessage={setMessage}
                    handleClose={handleClose}
                    portOfLoading={portOfLoading}
                    portOfDestination={portOfDestination}
                    shipmentOrgId={shipmentOrgId}
                    fetchButtonList={fetchButtonList}
                    proformaInvoiceList={proformaInvoiceList}
                    portMasters={portMasters}
                    bookingNumber={bookingNumber}

                />
            </CustomModal>

            <CustomModal open={updateModal}  >
                <UpdateBooking
                    fetchData={fetchData}
                    setMessage={setMessage}
                    handleClose={handleCloseUpdate}
                    shippingBookingId={shippingBookingId}
                    clientCompanyId={clientCompanyId}
                    shippingLines={shippingLines}
                    fclData={fclData}
                    directListData={directListData}
                    freightForwardAgencyData={freightForwardAgencyData}
                    customClearingAgencyData={customClearingAgencyData}
                    cifFobList={cifFobList}
                    currencyList={currencyList}
                    proformaInvoiceList={proformaInvoiceList}
                    portMasters={portMasters}


                />
            </CustomModal>

            <CustomModal
                open={viewModal}
                modalStyles={{
                    maxHeight: '70vh',
                    top: "10%",
                }}
                handleClose={handleCloseView}>
                <ShippingBookingView
                    handleClose={handleCloseView}
                    fetchData={fetchData}
                    setMessage={setMessage}
                    shippingBookingId={shippingBookingId}
                    clientCompanyId={clientCompanyId}
                    shippingLines={shippingLines}
                    fclData={fclData}
                    directListData={directListData}
                    freightForwardAgencyData={freightForwardAgencyData}
                    customClearingAgencyData={customClearingAgencyData}
                    cifFobList={cifFobList}
                    currencyList={currencyList}
                />
            </CustomModal>
            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />

            {/* </Main> */}
        </div>
    );
}
